import moment, { Moment } from "moment";
import { TimeEnum } from "../../../lib/enums";
import { Selections } from "../@types";
import { TimeEnumValue } from "../@types/EnumTypes";
import {
  DATE_FILTER,
  ISO_NO_MILLIS_MINUTES_HOURS_FORMAT_UTC,
  ISO_YEAR_MONTH_DAY_FORMAT_UTC
} from "../consts";
import {
  generateQueryWithSelections,
  getIsoStartEndDateFromCustom,
  getStartEndDateFromCustom,
  stringToTimestamp,
  stringToTimestampStart
} from "../util";

export type UnitType = "months" | "years";

const nextPeriodStart = (start: Moment, amount: number, unit: UnitType) =>
  moment(start).subtract(amount, unit).format(ISO_YEAR_MONTH_DAY_FORMAT_UTC);

const nextTotalCountPeriod = (
  period: string,
  amount: number,
  unit: UnitType
) => {
  const initialPeriod = stringToTimestamp(period);

  const start =
    period === DATE_FILTER.ALL
      ? moment()
      : moment(getIsoStartEndDateFromCustom(initialPeriod)[0]);

  return `[${nextPeriodStart(start, amount, unit)} TO ${start.format(
    ISO_YEAR_MONTH_DAY_FORMAT_UTC
  )}]`;
};

const fetchTotalCountParams = (
  selections: Selections,
  query: string,
  amount: number,
  unit: UnitType
) => {
  const { period_type: { value: period = "" } = {} } = selections || {};
  const nextPeriod = nextTotalCountPeriod(period, amount, unit);
  const nextSelections = {
    ...selections,
    period_type: {
      value: nextPeriod,
      label: DATE_FILTER.CUSTOM
    }
  } as Selections;
  const searchQuery = generateQueryWithSelections(nextSelections, query);
  return {
    query: searchQuery,
    selections: nextSelections
  };
};

const monthBefore = (value: string) =>
  moment(value)
    .subtract(1, "months")
    .startOf("days")
    .format(ISO_YEAR_MONTH_DAY_FORMAT_UTC);

const isOlderThan = (
  value: string | undefined | null,
  amount: number,
  unit: "days" | "months" | "years"
) => {
  if (!value) return false;
  return moment(value)
    .utc()
    .isSameOrBefore(moment().utc().subtract(amount, unit));
};

const getFetchPeriod = (period: TimeEnumValue | string) => {
  if (period == null || period === "") {
    return { start_search_date: null, end_search_date: null };
  }

  const isCustomPeriod = !Object.values(TimeEnum).includes(
    period as TimeEnumValue
  );
  if (isCustomPeriod) {
    const [start_search_date, end_search_date] =
      getStartEndDateFromCustom(period);
    return {
      start_search_date,
      end_search_date
    };
  }
  const start_search_date = stringToTimestampStart(
    period || "",
    ISO_YEAR_MONTH_DAY_FORMAT_UTC
  );
  const end_search_date = moment()
    .utc()
    .format(ISO_NO_MILLIS_MINUTES_HOURS_FORMAT_UTC);
  return {
    start_search_date,
    end_search_date
  };
};

export {
  nextPeriodStart,
  fetchTotalCountParams,
  getFetchPeriod,
  monthBefore,
  isOlderThan
};
